<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'News',

    metaInfo: { title: 'Berita Perusahaan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'news',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'news',
      },
    },
  }
</script>
